"use strict";

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
/*
	intro : count levels of a object project
	Author : chenchao
	Date : 2019-05-26
*/


var _types = require("./types.js");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var INIT_LEVEL = 1; // CountObjectLevel 

var CountObjectLevel = function () {
  function CountObjectLevel() {
    _classCallCheck(this, CountObjectLevel);

    this.maxRecursionLevel = this.RECURSION_LEVEL = INIT_LEVEL;
  } // count object level


  _createClass(CountObjectLevel, [{
    key: "count",
    value: function count(aimObject) {
      if ((0, _types2.default)(aimObject) !== "object") return 0; // count

      this.runCountLevel(aimObject);
      var level = this.maxRecursionLevel;
      this.maxRecursionLevel = INIT_LEVEL;
      return level;
    } // run count

  }, {
    key: "runCountLevel",
    value: function runCountLevel(aimObject) {
      if ((0, _types2.default)(aimObject) !== "object") return;
      var objKeys = Object.keys(aimObject);
      var i = 0;

      for (; i < objKeys.length; i++) {
        var temp = aimObject[objKeys[i]];

        if ((0, _types2.default)(temp) === "object") {
          this.RECURSION_LEVEL++;
          this.runCountLevel(temp);
        }
      } // get max recursion


      if (this.maxRecursionLevel * 1 < this.RECURSION_LEVEL * 1) {
        this.maxRecursionLevel = this.RECURSION_LEVEL;
      }

      this.RECURSION_LEVEL = INIT_LEVEL;
    }
  }]);

  return CountObjectLevel;
}(); // use one object cache to improve
// init a object 


var countFun = new CountObjectLevel();

var countObjectLevel = function countObjectLevel(aimObject) {
  return countFun.count(aimObject);
};

module.exports = countObjectLevel;